import React, {useState } from "react";
import './pdf_schooldashboard.css';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";


function PDFSchoolDashboard() {

  function createData(name, email, school, access_level, submittedDate, expireDate) {
    return { name, email, school, access_level, submittedDate,expireDate };
  }
  
  const rows = [
    createData("Alexander Hunt", "alexanderhunt@berkeley.net", "Malcolm X Elementary", "School", "04-27-2022", "07-31-2024"),
    createData("Candyce Cannon", "	candycecannon@berkeley.net", "Cragmont Elementary", "School", "04-27-2022", "07-31-2024")
  ];

  return (
    <>
      <div className='pdfdash_pageHeader'>
        {/* <div className="pageText">Manage Schools</div> */}
        <div id="pdfImage"><img alt="Delete School" src={require("../../assets/images/menuHeader_new.png")} className="pdfdash_logoSize"></img></div>
        <div className="pdfdash_ImageSub">CalSCHLS Coordinator Portal</div>
        <div className="pdfdash_pgTitle">DASHBOARD USERS</div>
        <div className="pdfdash_country">Alameda Unified (County Name will display here)</div>
      </div>
      <div className='pdfdash_pageContent'>
          <div className='pdfdash_userTable'>
            <TableContainer component={Paper} sx={{ height: "60vh" }} className="pdfdash_tableStyle">
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead className="pdfdash_setHeaderbackground">
                  <TableRow>
                    <TableCell align="left">NAME</TableCell>
                    <TableCell align="left">EMAIL</TableCell>
                    <TableCell align="left">SCHOOL</TableCell>
                    <TableCell align="left">ACCESS LEVEL</TableCell>
                    <TableCell align="left">SUBMITED DATE</TableCell>
                    <TableCell align="left">EXP. DATE</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="pdfdash_setBodybackground">
                  {rows.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell scope="row">{row.name}</TableCell>
                      <TableCell align="left">{row.email}</TableCell>
                      <TableCell align="left">{row.school}</TableCell>
                      <TableCell align="left">{row.access_level}</TableCell>
                      <TableCell align="left">{row.submittedDate}</TableCell>
                      <TableCell align="left">{row.expireDate}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
      </div>
    </>
  )
}

export default PDFSchoolDashboard